import PageContextProvider from "./store/context/context";
import Header from "./components/Header";
import Page from "./components/Page";
import Footer from "./components/Footer";
import COLORS from "./components/constants/colors";
import { identityCheckDauLog } from "./metrics/dau";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    identityCheckDauLog();
  }, []);

  return (
    <PageContextProvider>
      <div className="app-container flex flex-col">
        <div className="flex-2">
          <Header />
        </div>
        <div className="flex-1">
          <Page />
        </div>
        <div className="flex-2">
          <Footer bg={COLORS.bg_white} />
        </div>
      </div>
    </PageContextProvider>
  );
}

export default App;
